/* ALHUMO · Etiquetas tipo sticker
   Cambia las etiquetas en imagen de la app de etiquetas (PNG viejos) por
   stickers en SVG (sobre la foto) o píldoras con divisor (junto al precio).
   Para agregar una etiqueta nueva: añadir una entrada en MAP y en STYLE. */
(function () {
  var MAP = [
    { re: /QuedanPocos/i,         key: 'pocos' },
    { re: /Edici[^\/]*Limitada/i, key: 'limitada' },
    { re: /Beginners?_?choice/i,  key: 'empezar' },
    { re: /TeamFavs/i,            key: 'favorito' }
  ];
  var C = { terra: '#A9563F', sage: '#56705A', green: '#3E5A4B', cream: '#F5EFE4', blush: '#F2CBC8', plum: '#4A1F35' };

  /* ---- iconos ---- */
  function star(x, y, s, fill) {
    return '<path transform="translate(' + x + ' ' + y + ') scale(' + s / 24 + ') translate(-12 -12)" fill="' + fill +
      '" d="M12 0c.6 6.2 5.8 11.4 12 12-6.2.6-11.4 5.8-12 12-.6-6.2-5.8-11.4-12-12C6.2 11.4 11.4 6.2 12 0z"/>';
  }
  function sun(cx, cy, r, col) {
    var s = '<g stroke="' + col + '" stroke-width="1.6" fill="none" stroke-linecap="round">';
    s += '<path d="M' + (cx - r * .42) + ' ' + cy + 'a' + r * .42 + ' ' + r * .42 + ' 0 0 1 ' + r * .84 + ' 0"/>';
    for (var i = 0; i <= 10; i++) {
      var a = Math.PI + Math.PI * i / 10, r1 = r * .55, r2 = r * (i % 2 ? .82 : 1);
      s += '<line x1="' + (cx + r1 * Math.cos(a)).toFixed(1) + '" y1="' + (cy + r1 * Math.sin(a)).toFixed(1) +
           '" x2="' + (cx + r2 * Math.cos(a)).toFixed(1) + '" y2="' + (cy + r2 * Math.sin(a)).toFixed(1) + '"/>';
    }
    s += '<line x1="' + (cx - r * 1.15) + '" y1="' + cy + '" x2="' + (cx + r * 1.15) + '" y2="' + cy + '"/></g>';
    return s;
  }
  function leaf(cx, cy, s, col) {
    return '<g transform="translate(' + cx + ' ' + cy + ') scale(' + s / 40 + ') translate(-20 -20)" fill="none" stroke="' + col +
      '" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M20 38V6"/>' +
      '<path d="M20 30c-7-1-11-6-11-12 6 1 10 5 11 12z"/><path d="M20 30c7-1 11-6 11-12-6 1-10 5-11 12z"/>' +
      '<path d="M20 19c-5-1-8-5-8-10 5 1 8 4 8 10z"/><path d="M20 19c5-1 8-5 8-10-5 1-8 4-8 10z"/>' +
      '<path d="M20 9c-2-2-2-5 0-7 2 2 2 5 0 7z"/></g>';
  }
  function lotus(cx, cy, s, col) {
    return '<g transform="translate(' + cx + ' ' + cy + ') scale(' + s / 40 + ') translate(-20 -20)" fill="none" stroke="' + col +
      '" stroke-width="1.7" stroke-linejoin="round" stroke-linecap="round">' +
      '<path d="M20 31c-4-4-5-11 0-19 5 8 4 15 0 19z"/>' +
      '<path d="M18 31c-6-1-10-6-10-13 5 1 8 4 10 8"/><path d="M22 31c6-1 10-6 10-13-5 1-8 4-10 8"/>' +
      '<path d="M16 31.5c-6 0-11-3-13-8 4-.5 7 .5 9.5 2.5"/><path d="M24 31.5c6 0 11-3 13-8-4-.5-7 .5-9.5 2.5"/>' +
      '<path d="M8 35h24"/></g>';
  }
  function moon(cx, cy, s, col) {
    return '<path transform="translate(' + cx + ' ' + cy + ') scale(' + s / 24 + ') translate(-12 -12)" fill="' + col +
      '" d="M15 2a10 10 0 1 0 7 17.3A8.5 8.5 0 0 1 15 2z"/>';
  }

  /* ---- formas y texto ---- */
  function scallop(cx, cy, R, amp, n) {
    var d = '';
    for (var i = 0; i <= 360; i += 2) {
      var t = i * Math.PI / 180, r = R + amp * Math.cos(n * t);
      d += (i ? 'L' : 'M') + (cx + r * Math.cos(t)).toFixed(1) + ' ' + (cy + r * Math.sin(t)).toFixed(1);
    }
    return d + 'Z';
  }
  var uid = 0;
  function arcText(txt, r, top, col, size, spacing) {
    var id = 'alh-arc-' + (++uid);
    var d = 'M' + (100 - r) + ' 100A' + r + ' ' + r + ' 0 0 ' + (top ? 1 : 0) + ' ' + (100 + r) + ' 100';
    return '<path id="' + id + '" d="' + d + '" fill="none"/>' +
      '<text fill="' + col + '" font-size="' + size + '" font-weight="600" letter-spacing="' + spacing + '">' +
      '<textPath href="#' + id + '" xlink:href="#' + id + '" startOffset="50%" text-anchor="middle">' + txt + '</textPath></text>';
  }
  function line(txt, y, col, size, spacing) {
    return '<text x="100" y="' + y + '" fill="' + col + '" font-size="' + size + '" font-weight="600" letter-spacing="' + spacing +
      '" text-anchor="middle">' + txt + '</text>';
  }
  function ring(r, col, w, op) {
    return '<circle cx="100" cy="100" r="' + r + '" fill="none" stroke="' + col + '" stroke-width="' + w + '" stroke-opacity="' + op + '"/>';
  }

  var STYLE = {
    limitada: {
      label: 'Edición limitada', bg: C.terra, fg: C.cream, icon: function (c) { return star(12, 12, 20, c); },
      sticker: function () {
        return '<path d="' + scallop(100, 100, 90, 5, 12) + '" fill="' + C.terra + '"/>' +
          '<path d="' + scallop(100, 100, 81, 4.4, 12) + '" fill="none" stroke="' + C.cream + '" stroke-opacity=".75" stroke-width="1.4"/>' +
          star(100, 50, 20, C.cream) + line('EDICIÓN', 98, C.cream, 22, 2) + line('LIMITADA', 126, C.cream, 22, 2) + star(100, 154, 15, C.cream);
      }
    },
    pocos: {
      label: 'Quedan pocos', bg: C.sage, fg: C.cream, icon: function (c) { return moon(12, 12, 20, c); },
      sticker: function () {
        return '<circle cx="100" cy="100" r="92" fill="' + C.sage + '"/>' + ring(83, C.cream, 1.4, .7) +
          arcText('QUEDAN', 63, true, C.cream, 23, 6) + line('POCOS', 108, C.cream, 25, 5) + sun(100, 152, 32, C.cream);
      }
    },
    empezar: {
      label: 'Ideal para empezar', bg: C.cream, fg: C.green, border: C.green, icon: function (c) { return leaf(12, 12, 22, c); },
      sticker: function () {
        return '<circle cx="100" cy="100" r="91" fill="' + C.cream + '" stroke="' + C.green + '" stroke-width="2"/>' +
          ring(84, C.green, 1, .45) +
          arcText('IDEAL PARA', 62, true, C.green, 20, 3.4) + arcText('EMPEZAR', 75, false, C.green, 20, 3.4) +
          leaf(100, 100, 64, C.green) + star(31, 100, 11, C.green) + star(169, 100, 11, C.green);
      }
    },
    favorito: {
      label: 'Favorito del equipo', bg: C.blush, fg: C.plum, icon: function (c) { return lotus(12, 12, 24, c); },
      sticker: function () {
        return '<circle cx="100" cy="100" r="92" fill="' + C.blush + '"/>' + ring(84, C.plum, 1, .4) +
          arcText('FAVORITO', 62, true, C.plum, 20, 3.6) + arcText('DEL EQUIPO', 75, false, C.plum, 20, 3.2) +
          lotus(100, 98, 70, C.plum) + star(31, 100, 11, C.plum) + star(169, 100, 11, C.plum);
      }
    },
    bestseller: {
      label: 'Best seller', bg: C.cream, fg: C.terra, border: C.terra, icon: function (c) { return lotus(12, 12, 24, c); },
      sticker: function () {
        return '<path d="' + scallop(100, 100, 90, 5, 12) + '" fill="' + C.cream + '" stroke="' + C.terra + '" stroke-width="2.2"/>' +
          '<path d="' + scallop(100, 100, 80, 4.4, 12) + '" fill="none" stroke="' + C.terra + '" stroke-opacity=".5" stroke-width="1.2"/>' +
          lotus(100, 60, 46, C.terra) + line('BEST', 114, C.terra, 30, 2.4) + line('SELLER', 144, C.terra, 30, 2.4) +
          '<line x1="66" y1="162" x2="92" y2="162" stroke="' + C.terra + '" stroke-width="1.2"/>' +
          '<line x1="108" y1="162" x2="134" y2="162" stroke="' + C.terra + '" stroke-width="1.2"/>' + star(100, 162, 10, C.terra);
      }
    }
  };

  /* Etiquetas puestas por producto (handle de la URL -> etiqueta).
     Para agregar otro producto: copiar una línea con su handle. */
  var FLAGS = {
    'kit-completo-de-encuentra-oraculo-de-las-respuestas': 'bestseller'
  };

  function sticker(st) {
    return '<svg class="alh-sticker__svg" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false">' +
      st.sticker() + '</svg>';
  }
  function pill(st) {
    var w = st.label.split(' '), h = Math.floor(w.length / 2);
    var txt = w.length > 1 ? w.slice(0, h).join(' ') + '<br>' + w.slice(h).join(' ') : st.label;
    return '<svg class="alh-pill__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + st.icon(st.fg) + '</svg>' +
      '<span class="alh-pill__div"></span><span class="alh-pill__txt">' + txt + '</span>';
  }

  function swap(img) {
    if (!img || img.getAttribute('data-alh')) return;
    var src = (img.getAttribute('src') || '') + ' ' + (img.getAttribute('data-src') || '');
    for (var i = 0; i < MAP.length; i++) {
      if (!MAP[i].re.test(src)) continue;
      var st = STYLE[MAP[i].key];
      img.setAttribute('data-alh', '1');
      img.style.setProperty('display', 'none', 'important');
      var prev = img.previousElementSibling;
      if (prev && prev.classList && prev.classList.contains('alh-tag')) return;
      var onImage = true; /* sticker en todos lados (la píldora queda disponible si se cambia a false) */
      var tag = document.createElement('span');
      tag.className = (img.className || '') + ' alh-tag ' + (onImage ? 'alh-sticker' : 'alh-pill') + ' alh-tag--' + MAP[i].key;
      tag.setAttribute('role', 'img');
      tag.setAttribute('aria-label', st.label);
      if (onImage) {
        tag.innerHTML = sticker(st);
      } else {
        tag.style.background = st.bg; tag.style.color = st.fg;
        if (st.border) tag.style.borderColor = st.border;
        tag.innerHTML = pill(st);
      }
      var n = img.parentNode.querySelectorAll('.alh-tag').length;
      if (n) tag.style.setProperty('--alh-n', n);
      img.parentNode.insertBefore(tag, img);
      return;
    }
  }
  function flag(box, key, where) {
    if (!box || box.getAttribute('data-alh-flag')) return;
    box.setAttribute('data-alh-flag', key);
    if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
    var st = STYLE[key], tag = document.createElement('span');
    tag.className = 'alh-tag alh-sticker alh-flag alh-flag--' + where + ' alh-tag--' + key;
    tag.setAttribute('role', 'img');
    tag.setAttribute('aria-label', st.label);
    tag.innerHTML = sticker(st);
    box.appendChild(tag);
  }
  function scanFlags() {
    for (var handle in FLAGS) {
      var key = FLAGS[handle];
      var links = document.querySelectorAll('a[href*="/products/' + handle + '"]');
      for (var i = 0; i < links.length; i++) {
        var href = links[i].getAttribute('href').split('?')[0].split('#')[0];
        if (!new RegExp('/products/' + handle + '/?$').test(href)) continue;
        var card = links[i].closest && links[i].closest('.card-wrapper');
        if (card) flag(card.querySelector('.card__inner'), key, 'card');
      }
      if (new RegExp('/products/' + handle + '/?$').test(location.pathname)) {
        var first = document.querySelector('[id^="MainProduct-"] .product__media-list > li.product__media-item:first-child .product__media') ||
                    document.querySelector('.product__media-list .product__media');
        flag(first, key, 'product');
      }
    }
  }
  function scan() {
    scanFlags();
    var list = document.querySelectorAll('.bss_pl_img img, .bss_pb_img img, img[src*="Badge"]');
    for (var i = 0; i < list.length; i++) swap(list[i]);
  }
  function start() {
    scan();
    if (!window.MutationObserver) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 60); })
      .observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
